<template>
  <v-container fluid>
    <page-header
      :title="$t('my-page')"
      :use-list="['btnUpdate']"
      @btnUpdate="updateUserInfo"
    ></page-header>
    <v-row class="justify-center">
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title>
            <span>사용자 정보</span>
            <v-spacer />
            <v-btn outlined class="default-btn mr-2" @click="openPwChange"
              >PW 변경</v-btn
            >
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    :label="$t('id')"
                    v-model="user_info.user_id"
                    disabled
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    :label="$t('name')"
                    v-model="inptData.kor_nm"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="7" sm="9" md="10">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    :label="$t('phone')"
                    v-model="inptData.phone"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="5" sm="3" md="2">
                  <v-btn
                    outlined
                    block
                    class="default-btn mr-2"
                    @click="modal2 = true"
                    :disabled="phoneDisabled"
                    >인증</v-btn
                  >
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    :label="$t('email-address')"
                    v-model="inptData.email"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    type="password"
                    dense
                    outlined
                    hide-details="auto"
                    label="현재 비밀번호"
                    v-model="inptData.password"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <realgrid
                    ref="userSiteGrid"
                    class="mt-1 mb-5 w-full"
                    :options="grid.gridOption"
                    :fields="grid.gridFields"
                    :columns="grid.gridColumns"
                    :retrieveApi="gridRetrieveApi"
                    :saveApi="gridSaveApi"
                    :height="grid.height"
                  ></realgrid>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <general-dialog v-model="modal" :title="popupTitle" :buttons="buttons">
      <v-card flat>
        <v-card-text>
          <v-form ref="passwordForm">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="현재 비밀번호"
                  type="password"
                  v-model="change_pw.password"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :rules="[rules.required, rules.isPw]"
                  label="새 비밀번호"
                  type="password"
                  v-model="change_pw.re_password"
                  dense
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :rules="[
                    rules.required,
                    rules.isPw,
                    rules.equals(
                      change_pw.re_password2,
                      change_pw.re_password,
                      '비밀번호가 일치하지 않습니다.'
                    )
                  ]"
                  label="새 비밀번호확인"
                  type="password"
                  v-model="change_pw.re_password2"
                  dense
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </general-dialog>
    <general-dialog
      v-model="modal2"
      title="휴대폰 번호 변경"
      :buttons="buttons2"
    >
      <v-card flat>
        <v-card-text>
          <phone-certificate
            ref="phone"
            :phoneNumber="inptData.phone"
            v-if="true"
            @isCertificateOk="updatePhoneNumber"
            :toggle-init="toggleInit"
          ></phone-certificate>
        </v-card-text>
      </v-card>
    </general-dialog>
  </v-container>
</template>

<script>
import Message from '@/utils/message'
import { changePassword } from '@/api/common/user'
import PageHeader from '@/layout/components/PageHeader'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import localStore from '@/utils/localStore'
import Realgrid from '@/components/grid/Realgrid'
import PhoneCertificate from '@/layout/components/PhoneCertificate'
import irules from '@/utils/rules'
import {
  getUserInfo,
  setUserInfo,
  getUserSites,
  updateUserSites
} from '@/api/mypage/userInfo'

export default {
  name: 'mypage',
  components: {
    PageHeader,
    Realgrid,
    GeneralDialog,
    PhoneCertificate
  },
  data() {
    return {
      rules: irules,
      toggleInit: false,
      editGrid: false,
      modal: false,
      modal2: false,
      change: false, // 변경된 내용이 있는 경우
      isCertificateOk: false,
      grid: {
        height: 300,
        gridOption: {
          gridView: {
            edit: {
              editable: true,
              appendable: true,
              insertable: true,
              deletable: true
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridFields: [
          { fieldName: 'siteId', dataType: 'string' },
          { fieldName: 'description', dataType: 'string' },
          { fieldName: 'recFactor', dataType: 'string' },
          { fieldName: 'fitPrice', dataType: 'string' },
          { fieldName: 'siteCapa', dataType: 'string' },
          { fieldName: 'maxSmp', dataType: 'string' }
        ],
        gridColumns: [
          {
            name: 'siteId',
            fieldName: 'siteId',
            header: {
              text: '사이트 ID'
            },
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            width: 100,
            // editable 옵션이 false 일 경우, 수정할 수 없다.
            editable: false
          },
          {
            name: 'description',
            fieldName: 'description',
            header: {
              text: '사이트 명'
            },
            width: 200,
            styles: {
              textAlignment: 'center'
            },
            editable: false
          },
          {
            name: 'recFactor',
            fieldName: 'recFactor',
            header: {
              text: 'REC 가중치'
            },
            width: 100,
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          },
          {
            name: 'fitPrice',
            fieldName: 'fitPrice',
            header: {
              text: 'FIT 단가'
            },
            width: 70,
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          },
          {
            name: 'siteCapa',
            fieldName: 'siteCapa',
            header: {
              text: '사이트 용량'
            },
            width: 100,
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          },
          {
            name: 'maxSmp',
            fieldName: 'maxSmp',
            header: {
              text: 'SMP 상한'
            },
            width: 70,
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          }
        ]
      },
      inptData: {
        password: '',
        kor_nm: '',
        email: '',
        phone: ''
      },
      // 각 항목 validation 체크 flag
      // true가 validation 성공
      // false가 validation 실패
      // 휴대폰인증 완료시 기본으로 넘어오는 이름, 전화번호는 기본값으로 셋팅하고 validation 성공 처리
      isfixValueEmpty: false, // 인증정보(이름,전화번호) 고정으로 입력/수정 불가능
      initFlag: false,
      // validation false 일 때 메시지 초기값들
      popupTitle: '비밀번호 변경',
      popupWidths: {
        widthM: 'w-full',
        widthLg: 'w-2/5',
        widthXl: 'w-1/3'
      },
      popupHeights: {
        heightXl: 'con_popup_h_40',
        heightLg: 'con_popup_h_40'
      },
      user_info: {
        user_id: '',
        kor_nm: '',
        email: '',
        phone: ''
      },
      change_pw: {
        password: '',
        re_password: '',
        re_password2: '',
        user_id: ''
      },
      buttons: [
        {
          title: '변경',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            this.closePopup({ ok: true })
          }
        },
        {
          title: '취소',
          text: true,
          handler: () => {
            this.closePopup({ ok: false })
          }
        }
      ],
      buttons2: [
        {
          title: '확인',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            if (this.isCertificateOk) {
              Message.info('인증이 완료되었습니다.')
              this.inptData.phone = this.$refs.phone.phoneNumberF
            } else {
              Message.err('인증되지 않았습니다.')
            }
            this.modal2 = false
            this.toggleInit = !this.toggleInit
          }
        },
        {
          title: '취소',
          text: true,
          handler: () => {
            this.modal2 = false
            this.toggleInit = !this.toggleInit
          }
        }
      ]
    }
  },
  created() {
    this.getUserInfo()
  },
  computed: {
    phoneDisabled() {
      return this.inptData.phone === this.user_info.phone
    },
    checkChangeUserInfo() {
      return (
        this.editGrid ||
        this.inptData.phone !== this.user_info.phone ||
        this.inptData.kor_nm !== this.user_info.kor_nm ||
        this.inptData.email !== this.user_info.email
      )
    },
    gridRetrieveApi() {
      return getUserSites
    },
    gridSaveApi() {
      return updateUserSites
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.userSiteGrid.retrieve()
      this.$refs.userSiteGrid.getGridView().editOptions.editable = true
      this.$refs.userSiteGrid.getGridView().onEditChange = (
        grid,
        index,
        value
      ) => {
        this.editGrid = true
      }
      // this.$refs.userSiteGrid.getGridView().onEditRowChanged = (
      // ) => {
      //   this.editGrid = true
      // }
    })
    if (localStore.get('pw_change') === 'Y') {
      this.openPwChange()
    }
  },
  // computed 가 아닌 watch 를 쓰는 이유는 computed 내부에 dataSet이 들어가면 안됨
  watch: {
    modal(newValue) {
      if (!newValue) {
        this.change_pw.re_password = ''
        this.change_pw.password = ''
        this.change_pw.re_password2 = ''
      }
    },
    toggleInit() {
      // this.init()
    }
  },
  methods: {
    updatePhoneNumber(value) {
      this.isCertificateOk = true
    },
    getUserInfo() {
      getUserInfo().then(res => {
        this.change_pw.user_id = res.user_id
        this.user_info.user_id = res.user_id
        this.user_info.kor_nm = res.kor_nm
        this.user_info.email = res.email
        this.user_info.phone = res.phone
        this.inptData.kor_nm = res.kor_nm
        this.inptData.email = res.email
        this.inptData.phone = res.phone
      })
    },
    updateUserInfo() {
      if (this.checkChangeUserInfo) {
        console.log(this.$refs.userSiteGrid.getDataProvider().getAllStateRows())
        if (this.inptData.password === '') {
          Message.err('암호를 입력해주세요.')
        } else {
          if (
            this.inptData.phone !== this.user_info.phone &&
            !this.isCertificateOk
          ) {
            Message.warn('휴대폰 인증이 완료되지 않았습니다.')
          } else {
            setUserInfo(this.inptData).then(res => {
              if (res.body) {
                this.$refs.userSiteGrid.save()
                Message.success('저장되었습니다.')
                this.getUserInfo()
                this.inptData.password = ''
              } else {
                Message.err('현재 비밀번호가 일치하지 않습니다.')
              }
            })
          }
        }
      } else {
        Message.warn('변경된 정보가 없습니다.')
      }
    },
    openPwChange() {
      this.initFlag = false
      this.modal = true
    },
    closePopup(result) {
      this.initFlag = true
      if (result.ok) {
        if (this.$refs.passwordForm.validate()) {
          setUserInfo(this.change_pw).then(res => {
            if (res.body) {
              Message.success('비밀번호 변경이 완료 되었습니다.')
              this.$nextTick(() => {
                this.modal = false
                this.change_pw.re_password = ''
                this.change_pw.password = ''
                this.change_pw.re_password2 = ''
                localStore.set('pw_change', '') // 비밀번호 변경여부 초기화
              })
            } else {
              Message.err('현재 비밀번호가 일치하지 않습니다.')
            }
          })
        } else {
          Message.warn('비밀번호 양식이 맞지 않습니다.')
        }
      } else {
        this.modal = false
        this.change_pw.re_password = ''
        this.change_pw.password = ''
        this.change_pw.re_password2 = ''
      }
    },
    closePopup2(result) {
      if (result.ok) {
      } else {
        this.modal2 = false
      }
    }
  }
}
</script>

<style scoped>
.hiwayframe_btn {
  height: 15px;
  line-height: 12px;
}
</style>
